import { Modal } from 'antd';
import { useState } from 'react';
import receta from 'assets/images/receta.png';
import carnet from 'assets/images/carnet.jpg';
import styles from './InfoButton.module.less';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface Props {
	image: 'receta' | 'carnet';
}

export default function InfoButton({ image }: Props) {
	const [active, setActive] = useState(false);
	const src: { [key: string]: string } = { carnet, receta };
	return (
		<div className={styles.infoButton}>
			<Modal
				maskClosable
				footer={null}
				visible={active}
				onCancel={() => setActive(false)}
			>
				<img className={styles.infoButtonImg} src={src[image]} alt={image} />
			</Modal>
			<button type='button' onClick={() => setActive(true)}>
				<ExclamationCircleOutlined onClick={() => setActive(true)} />
			</button>
		</div>
	);
}
